import type { App } from 'vue'
import { createI18n } from 'vue-i18n'
import { ECountry } from '@/shared/enum/country.enum'
import { useI18n } from '@/shared/composables/useI18n'
import messages from '@/locales'

export const setupI18n = (app: App<Element>) => {
  const { country, setCountryInStore } = useI18n()

  setCountryInStore()

  app.use(
    createI18n({
      locale: country,
      fallbackLocale: ECountry.GT,
      legacy: false,
      globalInjection: true,
      messages,
      fallbackWarn: false,
      missingWarn: false
    })
  )
}
